export function validateEmail(email) {
  if (!email || typeof email !== 'string') {
    return false
  }
  
  // Enhanced email regex with international domain support
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u
  return emailRegex.test(email.trim())
}

export function validateRequired(value) {
  if (value === null || value === undefined) {
    return false
  }
  
  if (typeof value === 'string') {
    return value.trim().length > 0
  }
  
  return Boolean(value)
}

export function validateMaxLength(value, maxLength) {
  if (!value) {
    return true // null/undefined/empty string are valid
  }
  
  return String(value).length <= maxLength
}

